import { Component, EventEmitter, Input, Output } from '@angular/core'
import { EditorAssistanceBundle } from '../EditorAssistanceBundle'
import { RecurrenceEditingMode } from '../../../recurrence/recurrenceEditing'
import { AssistanceEditorComponent } from '../../assistance-editor/assistance-editor.component'
import { AssistanceEditorModalEditableHandler } from '../AssistanceEditorModalEditableHandler'
import { GroupSessionClientsComponent } from './group-session-clients/group-session-clients.component'

/**
 * Wrapper for assistance editor in group session mode.
 */
@Component({
  selector: 'app-group-session-editor',
  templateUrl: './group-session-editor.component.html',
  styleUrls: ['./group-session-editor.component.scss'],
  standalone: true,
  imports: [AssistanceEditorComponent, GroupSessionClientsComponent],
})
export class GroupSessionEditorComponent {
  @Input() bundle: EditorAssistanceBundle
  @Input() recurrenceEditingMode: RecurrenceEditingMode
  @Input() editableHandler: AssistanceEditorModalEditableHandler

  /** Emits the main assistance URID when the bundle membership changed and the modal should reload it. */
  @Output() reloadBundle = new EventEmitter<string>()
  @Output() notifyURIDChange = new EventEmitter<string>()
  @Output() bundleChildAssistanceDeleted = new EventEmitter<number>()
  @Output() recurrenceEditingModeChange = new EventEmitter<RecurrenceEditingMode>()
}
